// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"c49ec46b","360":"8dbdf594","387":"a5e15153","512":"2e3ea4c3","524":"6fba335d","776":"367682e2"}[chunkId] + ".chunk.js";
};